import { DataFromUrl, Job, JobCommon, PageStyle, SUCCESS_REPONSE_CODE, handleOtherResponseCode, 
         moment, UNPROCESSABLE_ENTITY_RESPONSE_CODE, REDIRECT, getEditInitalValues, getEditInitalOptionValues, CustomToastrAction}
         from "@/imports-files/pages/clients/jobs/common";


export async function cancelJob(router, setCancelPopup, setPageName, queryClient)
{
  const jobId   =   new DataFromUrl().getJobId();
  let idRegex   =   new RegExp("[0-9]")
  setCancelPopup(false);
  router.push({pathname: REDIRECT.client.jobs.index, query: {job_type: 'Active'}})
} 

function redirectTopage(values, newValues, step){
  switch (step) {
    case 1:
      values = {job: newValues}
      break;
    case 2:
      values = getEditInitalOptionValues(newValues, step)
      break;
    case 3:
      values = getEditInitalValues(newValues, step)
      break;
    case 4:
      values = {job: {job_stages_attributes: newValues.job_stages_attributes}}
      break;
    case 5:
      values = {scorecard_config_attributes: newValues.scorecard_config_attributes, job_competencies_attributes: newValues.job_competencies_attributes}
      break;
    case 6:
      values = {job: {integration_ids: newValues.integration_ids}}
      break;
  }
  return values
}

function getJobObject(values, step){
  let body = {}
  switch (step) {
    case 1:
      body = Object.assign({}, values)
      break;
    case 2:
      let screening_questions_attributes = values.job.screening_questions_attributes
      screening_questions_attributes = screening_questions_attributes.map((x) => {
        let order = 1
        x.question_options_attributes =  x.question_options_attributes.map((option) => {
          if(!option._destroy)
            option.order = order
          return option
        })
        return x
      })
      values.job.screening_questions_attributes = screening_questions_attributes
      body = Object.assign({}, values)
      break;
    case 3:
      let job_stages_attributes = values.job.job_stages_attributes
      let order = 1;
      job_stages_attributes = job_stages_attributes.map((x, index) => {
        delete x["stage_emails"]; 
        if(!x._destroy){
          x["order"] = order
          order = order + 1

          if(x.placeholder && x.placeholder.length > 0){
            if(x.job_stage_label_attributes.label.length > 0){
              x.job_stage_label_attributes.label = x.job_stage_label_attributes.label
            }
            else{
              x.job_stage_label_attributes.label = x.placeholder
            }
          }
        }
        return x })
      values.job.job_stages_attributes = job_stages_attributes
      body = Object.assign({}, values)
      break;
    case 4:
      body = Object.assign({}, values)
      break;
    case 5:
      body = {job: Object.assign({}, values)}
      break;
    case 6:
      body = Object.assign({}, values)
      break;
  }
  return body;
}

function showErrors(job, step)
{
  let message               =   "";
  const customToastrAction  =   new CustomToastrAction(); 

  switch(step){
    case 1:
      if(job?.hiring_manager_emails){
        message +=  `${job.hiring_manager_emails}`
      }
      if(job?.job_owner_emails){
        if(message.length > 0) { message += "</br>"}
        message += `${job.job_owner_emails}`
      }
      if(job?.start_date) { message = startDateMessage(message, job?.start_date)}
      break;
    case 2:
      if(job?.start_date) { message = startDateMessage(message, job?.start_date)}
      break;
    case 3:
      let jobStages = job.job_stages_attributes
      jobStages?.map((stage, index) => {
        if(jobStages[index].member_emails){
        if(message.length > 0) { message += " </br> "}
        message += `${jobStages[index].member_emails}`
        }
      })
      if(job?.start_date) { message = startDateMessage(message, job?.start_date)}
      break;
    case 4:
      if(job?.start_date) { message = startDateMessage(message, job?.start_date)}
      break;
    case 5:
      if(job?.start_date) { message = startDateMessage(message, job?.start_date)}
      break;
    case 6:
      if(job?.start_date) { message = startDateMessage(message, job?.start_date)}
      break;
  }

  if(message.length > 0) 
  { 
    customToastrAction.setNormalToastr(message, 'warning');
  }

}

export function startDateMessage(message, error){
  if(message.length > 0 ){return message = message + `</br> ${error}`}
  else { return error }
}

export async function draftJob(values, router, step, setPageName, queryClient, setJobStatus, setDisabledSaveButton, formRef, submitState){

  setDisabledSaveButton(true);
  let body              =   getJobObject(values, step)
  body.job.draft        =   true
  let result            =   {};
  const jobId           =   new DataFromUrl().getJobId();
  let idRegex           =   new RegExp("[0-9]")
  let createJobAction   =   false

  if(idRegex.test(jobId))
  {
    body.job.really_draft = true
    body.job.id = jobId
    result = await new JobCommon().saveAsDraft(body, jobId);
  }
  else
  {
    values.job.really_draft = true
    result = await new Job().createJob(values);
    createJobAction = true
  }
  
  const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction(); 
 
    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
      const response = result.data;
      setJobStatus("draft")
      values = redirectTopage(values, response, step)
      if((step == 2) || (step == 3) || (step == 5) )
      {
        setDisabledSaveButton(false); 
        if(submitState == 'draft'){
          customToastrAction.setNormalToastr(response.success, 'success');
        }
        else{
          previewJob(router, response.id)
        }
        return values;
      }
      if(createJobAction)
      {
        var link = REDIRECT.client.jobs.edit.replace('$job_id', response.id);
        router.push(link);
      }
      if(submitState == 'draft'){
        customToastrAction.setNormalToastr(response.success, 'success');
      }
      else{
        previewJob(router, response.id)
      }
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      showErrors(result.response.data.error.job, step)
      formRef.current.setStatus(result.response.data.error);
      break;
    default: 
      handleOtherResponseCode(status_code, router);
    }

    setDisabledSaveButton(false);
}

export async function previewJob(router, jobId){
  jobId = jobId || new DataFromUrl().getJobId();
  let preview_url    =  REDIRECT.client.jobs.preview_job.replace('$job_id', jobId)
  let protocol       =  window.location.protocol;
  let hostnamearray  =  window.location.host.split('.');
  let url            =  protocol + '//' + hostnamearray.join('.') + preview_url;
  window.open(url, '_blank');
}

export function todayDate(current)
{
  var yesterday = moment().subtract( 1, 'day' );
  return  current.isAfter( yesterday );
}

export function disableFutureDate(current)
{
  var today = moment();
  return  current.isBefore( today );
}

export function tomorrowDate(current)
{
  var yesterday = moment();
  return  current.isAfter( yesterday );
}

export function setFilledDate(filledDate)
{
  if(filledDate!=null && filledDate.includes('/'))
  {
    filledDate = filledDate.split('/');
    var year   = parseInt(filledDate[2]); 
    var month  = parseInt(filledDate[1]) - 1;
    var date   = parseInt(filledDate[0]);

    return new Date(year, month, date);
  }
  else
  {
    return null;
  }
}

export function setDateTimeFilledDate(filledDate)
{
  if(filledDate!=null && filledDate.includes('/') && filledDate.includes(':'))
  {
    filledDate    = filledDate.split(' ');
    var new_date   = filledDate[0].split('/');
    var year      =  parseInt(new_date[2]); 
    var month     =  parseInt(new_date[1]) - 1;
    var date      =  parseInt(new_date[0]);
    var new_time   = filledDate[1].split(':');
    var hour      =  parseInt(new_time[0]);
    var min       =  parseInt(new_time[1]);
    return new Date(year, month, date, hour, min);
  }
  else
  {
    return null;
  }
}


export function humanDateFormat(select_date)
{
  var select_date = new Date(select_date);
  var month = select_date.getMonth() + 1; //months from 1-12
  var day = select_date.getDate();
  var year = select_date.getFullYear();
  
  var newdate = day+ "/" + month + "/" + year ;
  return newdate;
}

export function hideDraft(editable){
  return editable ? '' : 'dnone'
}

export function cursorNone(editable){
  return editable ? '' : 'cursornone'
}

export function toggleDisabled(editable){
  return editable ? '' : 'toggle_disable'
}

export function textDisabled(editable){
  return editable ? '' : 'text_disable'
}

export function jobStatusBadge(status){
  if(status.toLowerCase() == "active"){
    return `${PageStyle.ClientCompany__ActiveDot}`
  }
  else if(status.toLowerCase() == "archived"){
    return `${PageStyle.ClientCompany__CloseDot}`
  }
}

export function arrayEquals(a, b) {
  return Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index]);
}

export function isCorrectTime(value){
  let time = value.replace(':', '')
  return !time.includes('-')
}

export function isValidDate(value){
  return !(value == 'Invalid date')
}

export function isFloat(value) {
  if(isNaN(value)) return false
  if(value){
    let number = Math.floor(value)
    if(value - number > 0){
      return true
    }
    else
      return false
  }
}